<ion-content>
  @if (mgm$ | async; as mgm) {
    <ion-grid>
      <ion-row>
        <ion-col size="12" class="content-col">
          <div class="content-col__header-block ion-text-center">
            <div class="header-icon">
              <img src="../../../assets/icon/Group 1000004624.svg" alt="horn-icon">
            </div>
            <h4>
              {{mgm?._more_info_title && mgm?._more_info_title[selectedLanguage] ?
              mgm?._more_info_title[selectedLanguage]:
              mgm?.more_info_title}}
            </h4>
            <p>
              {{mgm?._more_info_subtitle && mgm?._more_info_subtitle[selectedLanguage] ?
              mgm?._more_info_subtitle[selectedLanguage]:
              mgm?.more_info_subtitle}}
            </p>
          </div>
          <div class="info-container">
            @for (
              mgmInfo of intMoreInfoDetails ? intMoreInfoDetails : mgm?._more_info_details[selectedLanguage]; track
              mgmInfo) {
              <ion-item
                class="total-list-wrapper content-col__content-block">
                <ion-row class="list-wrapper">
                  <ion-col class="ion-no-padding contents-wrapper">
                    <img src="../../../assets/images/tick.svg" class="tick-mark" />
                    <h2 [innerHTML]="mgmInfo"></h2>
                  </ion-col>
                </ion-row>
              </ion-item>
            }
            <h1 class="bottom-sheet-back-link" (click)="backToMgm()">&larr;{{ "referral-model.Back" | translate }}</h1>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  }
</ion-content>